import { render } from "./CreateKeySection.vue?vue&type=template&id=47e17afa"
import script from "./CreateKeySection.vue?vue&type=script&lang=js"
export * from "./CreateKeySection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__